// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3EQ8m","list":"BalanceDue_list__2UpZo","listRow":"BalanceDue_listRow__1Er0H","total":"BalanceDue_total__31b2H"};